import store from '../store/store';
import { mutatorAction } from 'satcheljs';
import { SubscriberType } from '../store/schema/subscriberType';

export default mutatorAction('setSubscriberType', function setSubscriberType(
    response: SubscriberType
) {
    store.subscriberType = response;
});
